

// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
 import {Deserializable} from "./deserializable.model";

export class Permission {

  public job_id?: number; 
  public subject_id?: number; 
  public permission_id?: number;
  public created_by: number;
  public created_level: number;
  public file_brand_id: number;
  public file_access_level: number;
  public file_password: string;
  public file_edit_level: number;
  public updated_by?: number;
  public updated_date?: string;
  public brand_type_id: number;
  public brand_type_id_2?: number;  //cestom assign prprtety

  public agent_access_array?: any = []; // collect current agent ids
  public report_access_array?: any = []; // collect client
  public invoice_access_array?: any = []; // collect client
  public user_access_array?: any = []; // of selected associated users.

  assigned_to_agents?: any;

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): Permission {
    Object.assign(this, input);

    return this;
  }/*  */


}

  // Set the Stats


